import { render, staticRenderFns } from "./TaxBlock.vue?vue&type=template&id=69eb1a81&scoped=true"
import script from "./TaxBlock.vue?vue&type=script&lang=js"
export * from "./TaxBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69eb1a81",
  null
  
)

export default component.exports